import script from "./AudioModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioModal.vue?vue&type=script&setup=true&lang=js"

import "./AudioModal.vue?vue&type=style&index=0&id=67e71500&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e71500"]])

export default __exports__